/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";
import {
  Salutation,
  salutationToNumber,
  salutationFromJSON,
  salutationToJSON,
} from "./User/Salutation";

export interface ChatBotData {
  id: string;
  lastSeenCookieValue: string;
  regionName: string;
  source: string;
  lastName: string;
  salutation: Salutation;
  metaInformation?: ChatBotData_MetaInformation;
  chatBotType: ChatBotData_ChatBotType;
}

export enum ChatBotData_ChatBotType {
  ChatBotTypeUnknown = "ChatBotTypeUnknown",
  PreBooking = "PreBooking",
  PostBooking = "PostBooking",
}

export function chatBotData_ChatBotTypeFromJSON(
  object: any
): ChatBotData_ChatBotType {
  switch (object) {
    case 0:
    case "ChatBotTypeUnknown":
      return ChatBotData_ChatBotType.ChatBotTypeUnknown;
    case 1:
    case "PreBooking":
      return ChatBotData_ChatBotType.PreBooking;
    case 2:
    case "PostBooking":
      return ChatBotData_ChatBotType.PostBooking;
    default:
      throw new globalThis.Error(
        "Unrecognized enum value " +
          object +
          " for enum ChatBotData_ChatBotType"
      );
  }
}

export function chatBotData_ChatBotTypeToJSON(
  object: ChatBotData_ChatBotType
): string {
  switch (object) {
    case ChatBotData_ChatBotType.ChatBotTypeUnknown:
      return "ChatBotTypeUnknown";
    case ChatBotData_ChatBotType.PreBooking:
      return "PreBooking";
    case ChatBotData_ChatBotType.PostBooking:
      return "PostBooking";
    default:
      return "UNKNOWN";
  }
}

export function chatBotData_ChatBotTypeToNumber(
  object: ChatBotData_ChatBotType
): number {
  switch (object) {
    case ChatBotData_ChatBotType.ChatBotTypeUnknown:
      return 0;
    case ChatBotData_ChatBotType.PreBooking:
      return 1;
    case ChatBotData_ChatBotType.PostBooking:
      return 2;
    default:
      return 0;
  }
}

export interface ChatBotData_MetaInformation {
  /** json encoded meta information for pbe */
  serviceCode: string;
  bookingHash: string;
  anonymousLoginSalt: string;
}

export interface ChattyOfferParams {
  withLoyaltyDonationChoices: boolean;
  withRoomContent: boolean;
  communicateAurumToursDiscount: boolean;
  isGoldClubCustomer: boolean;
  isGoldClubHotelCustomer: boolean;
  ssoId: number;
  ibeSplitId: number;
  bookingId: string;
  agent: string;
  imageOrder: string;
  userId: string;
  wpset: string;
  clickStreamData: { [key: string]: string };
}

export interface ChattyOfferParams_ClickStreamDataEntry {
  key: string;
  value: string;
}

function createBaseChatBotData(): ChatBotData {
  return {
    id: "",
    lastSeenCookieValue: "",
    regionName: "",
    source: "",
    lastName: "",
    salutation: Salutation.SalutationUnknown,
    metaInformation: undefined,
    chatBotType: ChatBotData_ChatBotType.ChatBotTypeUnknown,
  };
}

export const ChatBotData = {
  encode(
    message: ChatBotData,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.lastSeenCookieValue !== "") {
      writer.uint32(18).string(message.lastSeenCookieValue);
    }
    if (message.regionName !== "") {
      writer.uint32(26).string(message.regionName);
    }
    if (message.source !== "") {
      writer.uint32(34).string(message.source);
    }
    if (message.lastName !== "") {
      writer.uint32(42).string(message.lastName);
    }
    if (message.salutation !== Salutation.SalutationUnknown) {
      writer.uint32(48).int32(salutationToNumber(message.salutation));
    }
    if (message.metaInformation !== undefined) {
      ChatBotData_MetaInformation.encode(
        message.metaInformation,
        writer.uint32(58).fork()
      ).ldelim();
    }
    if (message.chatBotType !== ChatBotData_ChatBotType.ChatBotTypeUnknown) {
      writer
        .uint32(64)
        .int32(chatBotData_ChatBotTypeToNumber(message.chatBotType));
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ChatBotData {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatBotData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.id = reader.string();
          break;
        case 2:
          message.lastSeenCookieValue = reader.string();
          break;
        case 3:
          message.regionName = reader.string();
          break;
        case 4:
          message.source = reader.string();
          break;
        case 5:
          message.lastName = reader.string();
          break;
        case 6:
          message.salutation = salutationFromJSON(reader.int32());
          break;
        case 7:
          message.metaInformation = ChatBotData_MetaInformation.decode(
            reader,
            reader.uint32()
          );
          break;
        case 8:
          message.chatBotType = chatBotData_ChatBotTypeFromJSON(reader.int32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): ChatBotData {
    return {
      id: isSet(object.id) ? String(object.id) : "",
      lastSeenCookieValue: isSet(object.lastSeenCookieValue)
        ? String(object.lastSeenCookieValue)
        : "",
      regionName: isSet(object.regionName) ? String(object.regionName) : "",
      source: isSet(object.source) ? String(object.source) : "",
      lastName: isSet(object.lastName) ? String(object.lastName) : "",
      salutation: isSet(object.salutation)
        ? salutationFromJSON(object.salutation)
        : Salutation.SalutationUnknown,
      metaInformation: isSet(object.metaInformation)
        ? ChatBotData_MetaInformation.fromJSON(object.metaInformation)
        : undefined,
      chatBotType: isSet(object.chatBotType)
        ? chatBotData_ChatBotTypeFromJSON(object.chatBotType)
        : ChatBotData_ChatBotType.ChatBotTypeUnknown,
    };
  },

  toJSON(message: ChatBotData): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    message.lastSeenCookieValue !== undefined &&
      (obj.lastSeenCookieValue = message.lastSeenCookieValue);
    message.regionName !== undefined && (obj.regionName = message.regionName);
    message.source !== undefined && (obj.source = message.source);
    message.lastName !== undefined && (obj.lastName = message.lastName);
    message.salutation !== undefined &&
      (obj.salutation = salutationToJSON(message.salutation));
    message.metaInformation !== undefined &&
      (obj.metaInformation = message.metaInformation
        ? ChatBotData_MetaInformation.toJSON(message.metaInformation)
        : undefined);
    message.chatBotType !== undefined &&
      (obj.chatBotType = chatBotData_ChatBotTypeToJSON(message.chatBotType));
    return obj;
  },

  fromPartial(object: DeepPartial<ChatBotData>): ChatBotData {
    const message = createBaseChatBotData();
    message.id = object.id ?? "";
    message.lastSeenCookieValue = object.lastSeenCookieValue ?? "";
    message.regionName = object.regionName ?? "";
    message.source = object.source ?? "";
    message.lastName = object.lastName ?? "";
    message.salutation = object.salutation ?? Salutation.SalutationUnknown;
    message.metaInformation =
      object.metaInformation !== undefined && object.metaInformation !== null
        ? ChatBotData_MetaInformation.fromPartial(object.metaInformation)
        : undefined;
    message.chatBotType =
      object.chatBotType ?? ChatBotData_ChatBotType.ChatBotTypeUnknown;
    return message;
  },
};

function createBaseChatBotData_MetaInformation(): ChatBotData_MetaInformation {
  return { serviceCode: "", bookingHash: "", anonymousLoginSalt: "" };
}

export const ChatBotData_MetaInformation = {
  encode(
    message: ChatBotData_MetaInformation,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.serviceCode !== "") {
      writer.uint32(10).string(message.serviceCode);
    }
    if (message.bookingHash !== "") {
      writer.uint32(18).string(message.bookingHash);
    }
    if (message.anonymousLoginSalt !== "") {
      writer.uint32(26).string(message.anonymousLoginSalt);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): ChatBotData_MetaInformation {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatBotData_MetaInformation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.serviceCode = reader.string();
          break;
        case 2:
          message.bookingHash = reader.string();
          break;
        case 3:
          message.anonymousLoginSalt = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): ChatBotData_MetaInformation {
    return {
      serviceCode: isSet(object.serviceCode) ? String(object.serviceCode) : "",
      bookingHash: isSet(object.bookingHash) ? String(object.bookingHash) : "",
      anonymousLoginSalt: isSet(object.anonymousLoginSalt)
        ? String(object.anonymousLoginSalt)
        : "",
    };
  },

  toJSON(message: ChatBotData_MetaInformation): unknown {
    const obj: any = {};
    message.serviceCode !== undefined &&
      (obj.serviceCode = message.serviceCode);
    message.bookingHash !== undefined &&
      (obj.bookingHash = message.bookingHash);
    message.anonymousLoginSalt !== undefined &&
      (obj.anonymousLoginSalt = message.anonymousLoginSalt);
    return obj;
  },

  fromPartial(
    object: DeepPartial<ChatBotData_MetaInformation>
  ): ChatBotData_MetaInformation {
    const message = createBaseChatBotData_MetaInformation();
    message.serviceCode = object.serviceCode ?? "";
    message.bookingHash = object.bookingHash ?? "";
    message.anonymousLoginSalt = object.anonymousLoginSalt ?? "";
    return message;
  },
};

function createBaseChattyOfferParams(): ChattyOfferParams {
  return {
    withLoyaltyDonationChoices: false,
    withRoomContent: false,
    communicateAurumToursDiscount: false,
    isGoldClubCustomer: false,
    isGoldClubHotelCustomer: false,
    ssoId: 0,
    ibeSplitId: 0,
    bookingId: "",
    agent: "",
    imageOrder: "",
    userId: "",
    wpset: "",
    clickStreamData: {},
  };
}

export const ChattyOfferParams = {
  encode(
    message: ChattyOfferParams,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.withLoyaltyDonationChoices === true) {
      writer.uint32(56).bool(message.withLoyaltyDonationChoices);
    }
    if (message.withRoomContent === true) {
      writer.uint32(64).bool(message.withRoomContent);
    }
    if (message.communicateAurumToursDiscount === true) {
      writer.uint32(72).bool(message.communicateAurumToursDiscount);
    }
    if (message.isGoldClubCustomer === true) {
      writer.uint32(80).bool(message.isGoldClubCustomer);
    }
    if (message.isGoldClubHotelCustomer === true) {
      writer.uint32(88).bool(message.isGoldClubHotelCustomer);
    }
    if (message.ssoId !== 0) {
      writer.uint32(24).uint32(message.ssoId);
    }
    if (message.ibeSplitId !== 0) {
      writer.uint32(32).uint32(message.ibeSplitId);
    }
    if (message.bookingId !== "") {
      writer.uint32(10).string(message.bookingId);
    }
    if (message.agent !== "") {
      writer.uint32(18).string(message.agent);
    }
    if (message.imageOrder !== "") {
      writer.uint32(42).string(message.imageOrder);
    }
    if (message.userId !== "") {
      writer.uint32(50).string(message.userId);
    }
    if (message.wpset !== "") {
      writer.uint32(106).string(message.wpset);
    }
    Object.entries(message.clickStreamData).forEach(([key, value]) => {
      ChattyOfferParams_ClickStreamDataEntry.encode(
        { key: key as any, value },
        writer.uint32(98).fork()
      ).ldelim();
    });
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ChattyOfferParams {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChattyOfferParams();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 7:
          message.withLoyaltyDonationChoices = reader.bool();
          break;
        case 8:
          message.withRoomContent = reader.bool();
          break;
        case 9:
          message.communicateAurumToursDiscount = reader.bool();
          break;
        case 10:
          message.isGoldClubCustomer = reader.bool();
          break;
        case 11:
          message.isGoldClubHotelCustomer = reader.bool();
          break;
        case 3:
          message.ssoId = reader.uint32();
          break;
        case 4:
          message.ibeSplitId = reader.uint32();
          break;
        case 1:
          message.bookingId = reader.string();
          break;
        case 2:
          message.agent = reader.string();
          break;
        case 5:
          message.imageOrder = reader.string();
          break;
        case 6:
          message.userId = reader.string();
          break;
        case 13:
          message.wpset = reader.string();
          break;
        case 12:
          const entry12 = ChattyOfferParams_ClickStreamDataEntry.decode(
            reader,
            reader.uint32()
          );
          if (entry12.value !== undefined) {
            message.clickStreamData[entry12.key] = entry12.value;
          }
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): ChattyOfferParams {
    return {
      withLoyaltyDonationChoices: isSet(object.withLoyaltyDonationChoices)
        ? Boolean(object.withLoyaltyDonationChoices)
        : false,
      withRoomContent: isSet(object.withRoomContent)
        ? Boolean(object.withRoomContent)
        : false,
      communicateAurumToursDiscount: isSet(object.communicateAurumToursDiscount)
        ? Boolean(object.communicateAurumToursDiscount)
        : false,
      isGoldClubCustomer: isSet(object.isGoldClubCustomer)
        ? Boolean(object.isGoldClubCustomer)
        : false,
      isGoldClubHotelCustomer: isSet(object.isGoldClubHotelCustomer)
        ? Boolean(object.isGoldClubHotelCustomer)
        : false,
      ssoId: isSet(object.ssoId) ? Number(object.ssoId) : 0,
      ibeSplitId: isSet(object.ibeSplitId) ? Number(object.ibeSplitId) : 0,
      bookingId: isSet(object.bookingId) ? String(object.bookingId) : "",
      agent: isSet(object.agent) ? String(object.agent) : "",
      imageOrder: isSet(object.imageOrder) ? String(object.imageOrder) : "",
      userId: isSet(object.userId) ? String(object.userId) : "",
      wpset: isSet(object.wpset) ? String(object.wpset) : "",
      clickStreamData: isObject(object.clickStreamData)
        ? Object.entries(object.clickStreamData).reduce<{
            [key: string]: string;
          }>((acc, [key, value]) => {
            acc[key] = String(value);
            return acc;
          }, {})
        : {},
    };
  },

  toJSON(message: ChattyOfferParams): unknown {
    const obj: any = {};
    message.withLoyaltyDonationChoices !== undefined &&
      (obj.withLoyaltyDonationChoices = message.withLoyaltyDonationChoices);
    message.withRoomContent !== undefined &&
      (obj.withRoomContent = message.withRoomContent);
    message.communicateAurumToursDiscount !== undefined &&
      (obj.communicateAurumToursDiscount =
        message.communicateAurumToursDiscount);
    message.isGoldClubCustomer !== undefined &&
      (obj.isGoldClubCustomer = message.isGoldClubCustomer);
    message.isGoldClubHotelCustomer !== undefined &&
      (obj.isGoldClubHotelCustomer = message.isGoldClubHotelCustomer);
    message.ssoId !== undefined && (obj.ssoId = Math.round(message.ssoId));
    message.ibeSplitId !== undefined &&
      (obj.ibeSplitId = Math.round(message.ibeSplitId));
    message.bookingId !== undefined && (obj.bookingId = message.bookingId);
    message.agent !== undefined && (obj.agent = message.agent);
    message.imageOrder !== undefined && (obj.imageOrder = message.imageOrder);
    message.userId !== undefined && (obj.userId = message.userId);
    message.wpset !== undefined && (obj.wpset = message.wpset);
    obj.clickStreamData = {};
    if (message.clickStreamData) {
      Object.entries(message.clickStreamData).forEach(([k, v]) => {
        obj.clickStreamData[k] = v;
      });
    }
    return obj;
  },

  fromPartial(object: DeepPartial<ChattyOfferParams>): ChattyOfferParams {
    const message = createBaseChattyOfferParams();
    message.withLoyaltyDonationChoices =
      object.withLoyaltyDonationChoices ?? false;
    message.withRoomContent = object.withRoomContent ?? false;
    message.communicateAurumToursDiscount =
      object.communicateAurumToursDiscount ?? false;
    message.isGoldClubCustomer = object.isGoldClubCustomer ?? false;
    message.isGoldClubHotelCustomer = object.isGoldClubHotelCustomer ?? false;
    message.ssoId = object.ssoId ?? 0;
    message.ibeSplitId = object.ibeSplitId ?? 0;
    message.bookingId = object.bookingId ?? "";
    message.agent = object.agent ?? "";
    message.imageOrder = object.imageOrder ?? "";
    message.userId = object.userId ?? "";
    message.wpset = object.wpset ?? "";
    message.clickStreamData = Object.entries(
      object.clickStreamData ?? {}
    ).reduce<{ [key: string]: string }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = String(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBaseChattyOfferParams_ClickStreamDataEntry(): ChattyOfferParams_ClickStreamDataEntry {
  return { key: "", value: "" };
}

export const ChattyOfferParams_ClickStreamDataEntry = {
  encode(
    message: ChattyOfferParams_ClickStreamDataEntry,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): ChattyOfferParams_ClickStreamDataEntry {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChattyOfferParams_ClickStreamDataEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.key = reader.string();
          break;
        case 2:
          message.value = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): ChattyOfferParams_ClickStreamDataEntry {
    return {
      key: isSet(object.key) ? String(object.key) : "",
      value: isSet(object.value) ? String(object.value) : "",
    };
  },

  toJSON(message: ChattyOfferParams_ClickStreamDataEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined && (obj.value = message.value);
    return obj;
  },

  fromPartial(
    object: DeepPartial<ChattyOfferParams_ClickStreamDataEntry>
  ): ChattyOfferParams_ClickStreamDataEntry {
    const message = createBaseChattyOfferParams_ClickStreamDataEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var globalThis: any = (() => {
  if (typeof globalThis !== "undefined") return globalThis;
  if (typeof self !== "undefined") return self;
  if (typeof window !== "undefined") return window;
  if (typeof global !== "undefined") return global;
  throw "Unable to locate global object";
})();

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined;

type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
